/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentAcademicRecordTitle model module.
 * @module model/StudentAcademicRecordTitle
 * @version 1.0
 */
class StudentAcademicRecordTitle {
    /**
     * Constructs a new <code>StudentAcademicRecordTitle</code>.
     * @alias module:model/StudentAcademicRecordTitle
     */
    constructor() { 
        
        StudentAcademicRecordTitle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentAcademicRecordTitle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentAcademicRecordTitle} obj Optional instance to populate.
     * @return {module:model/StudentAcademicRecordTitle} The populated <code>StudentAcademicRecordTitle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentAcademicRecordTitle();

            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_name')) {
                obj['academic_program_name'] = ApiClient.convertToType(data['academic_program_name'], 'String');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
            if (data.hasOwnProperty('more_info')) {
                obj['more_info'] = ApiClient.convertToType(data['more_info'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = ApiClient.convertToType(data['documents'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * Mapeado desde StudentAcademicRecordTitle.academic_program_id
 * @member {Number} academic_program_id
 */
StudentAcademicRecordTitle.prototype['academic_program_id'] = undefined;

/**
 * Mapeado desde StudentAcademicRecordTitle.academic_program_translation
 * @member {String} academic_program_name
 */
StudentAcademicRecordTitle.prototype['academic_program_name'] = undefined;

/**
 * Mapeado desde StudentAcademicRecordTitle.comments
 * @member {String} comments
 */
StudentAcademicRecordTitle.prototype['comments'] = undefined;

/**
 * @member {String} more_info
 */
StudentAcademicRecordTitle.prototype['more_info'] = undefined;

/**
 * Mapeado desde StudentAcademicRecordTitle.status_id
 * @member {Number} status_id
 */
StudentAcademicRecordTitle.prototype['status_id'] = undefined;

/**
 * Texto derivado de status_id
 * @member {String} status
 */
StudentAcademicRecordTitle.prototype['status'] = undefined;

/**
 * @member {Array.<Object>} documents
 */
StudentAcademicRecordTitle.prototype['documents'] = undefined;






export default StudentAcademicRecordTitle;

